import React, { useState, useMemo } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";
import { getWustlDoCM } from "../../../../pages/variant/components/cancer-dbs/selectors/cancer-dbs.selectors";
import { getPathogenicityColorByAllNames } from "../../../../common/helpers/Constant";

const DoCMCard = ({ card, DoCMData }) => {
  const isDisabled = !DoCMData;
  const [text, setText] = useState();
  const [color, setColor] = useState();

  useMemo(() => {
    if (DoCMData && DoCMData[0]?.diseases) {
      setText("Likely Pathogenic");
      setColor(getPathogenicityColorByAllNames("likely pathogenic"));
      for (const disease of DoCMData[0].diseases) {
        if (disease.tags) {
          const result = disease.tags.filter((tag) => tag === "pathogenic");
          if (result.length > 0) {
            setColor(getPathogenicityColorByAllNames("pathogenic"));
            setText("Pathogenic");
            break;
          }
        }
      }
    }
  }, [DoCMData]);

  return (
    <CardWrapper
      {...card}
      isDisabled={isDisabled}
      color={color}
      secondaryTitle={
        DoCMData && DoCMData.length > 0 ? (
          <span style={{ color }}>
            <b>{text}</b>
          </span>
        ) : (
          <></>
        )
      }
    >
      {DoCMData && DoCMData.length > 0 ? (
        <>
          <div className="tw-font-bold" data-testid="docm-total-diseases-data">
            <span className="tw-font-normal tw-pr-1">Diseases:</span>
            {DoCMData[0]?.diseases ? DoCMData[0].diseases.length : 0}
          </div>
          <div className="tw-font-bold" data-testid="docm-total-drugs-data">
            <span className="tw-font-normal tw-pr-1">Drugs:</span>
            {DoCMData[0]?.drugs ? DoCMData[0].drugs.length : 0}
          </div>
        </>
      ) : null}
    </CardWrapper>
  );
};

DoCMCard.propTypes = {
  card: PropTypes.instanceOf(Card).isRequired,
  DoCMData: PropTypes.arrayOf(
    PropTypes.shape({
      version: PropTypes.string,
      diseases: PropTypes.arrayOf(
        PropTypes.shape({
          disease: PropTypes.string,
          doid: PropTypes.string,
          pub_med_references: PropTypes.arrayOf(PropTypes.number),
          tags: PropTypes.arrayOf(PropTypes.string),
        })
      ),
      drugs: PropTypes.arrayOf(
        PropTypes.shape({
          effect: PropTypes.string,
          evidence: PropTypes.string,
          pathway: PropTypes.string,
          source: PropTypes.string,
          status: PropTypes.string,
          therapeutic_context: PropTypes.string,
        })
      ),
    })
  ),
};

DoCMCard.defaultProps = {
  DoCMData: null,
};

const mapStateToProps = (state) => ({
  DoCMData: getWustlDoCM(state),
});

export default connect(mapStateToProps)(DoCMCard);
